<template>
    <div class="container-download">
        <!-- <p class="download-title">Download by Trait</p>
        <div style="display: flex; justify-content: center">
            <t-select
                class="search-select"
                :options="downloadOption"
                @search="search"
                placeholder="eg: lung cancer"
                v-model="downloadId"
            ></t-select>

            <button class="btn btn-default button-download" @click="handleDownloadFile">
                <i class="glyphicon glyphicon-save"></i>
            </button>
        </div> -->

        <div class="page-intro">
            <div>
                <span class="eyebrow">COEXCELL DATA LIBRARY</span>
                <h1>Download</h1>
                <p>Access curated coexpression datasets, module annotations and enrichment results.</p>
            </div>
            <div class="file-count"><strong>{{ downloadList.length }}</strong><span>available files</span></div>
        </div>
        <section class="download-panel">
            <div class="files-heading"><span>Available Files</span><span class="heading-rule"></span></div>
            <div class="table-wrap"><table class="download-table">
            <thead>
                <tr>
                    <th>Description</th>
                    <th>Details</th>
                    <th>Format</th>
                    <th>Size</th>
                    <th>Download Link</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="file in downloadList">
                    <td>{{ file.description }}</td>
                    <td>{{ file.details }}</td>
                    <td><span class="file-chip">{{ file.format }}</span></td>
                    <td class="size-cell">{{ file.size }}</td>
                    <td>
                        <a v-if="file.available !== false && file.downloadUrl" :href="file.downloadUrl" target="_blank" class="download-link"><i class="el-icon-download"></i><span>Download</span></a>
                        <span v-else class="unavailable">Will be available after the paper is published.</span>
                    </td>
                </tr>
            </tbody>
            </table></div>
        </section>
    </div>
</template>

<script>
const options = new Array(30).fill(1).map((v, i) => {
    return {
        label: i,
        value: i,
    };
});
const downloadList = [
    {
        description: "The correlation data displayed in website",
        details: "Containing the results with adjusted p value < 0.05, correlation coefficient > 0.3.",
        format: "zip",
        size: "31G",
        key: "cagc-data", available: true, downloadUrl: "/api/download/file/cagc-data",
    },
    {
        description: "Gene composition for each individual module",
        details: "Gene composition for each individual module.",
        format: "csv",
        size: "26MB",
        key: "module-composition", available: true, downloadUrl: "/api/download/file/module-composition",
    },
    {
        description: "Full correlation data",
        details: "Will be available after the paper is published.",
        format: "-",
        size: "-",
        key: "full-correlation", available: false, downloadUrl: "",
    }
];

export default {
    name: "downloads",

    data() {
        return {
            options,
            downloadList: [],
            downloadId: "",
            downloadOption: [],
        };
    },

    created() {
        this.getDownloadData();
    },

    methods: {
        async search(val) {
            let params = {
                keyword: val,
                pageSize: 20,
            };

            let res = await this.$ajax.get("download/search", params);
            this.downloadOption = (res.data.records || []).map((v) => {
                return {
                    label: v.name,
                    value: v.downloadUrl,
                };
            });
        },

        async getDownloadData() {
            try {
                const res = await this.$ajax.get("download/list");
                this.downloadList = res.data || downloadList;
            } catch (e) {
                this.downloadList = downloadList;
            }
        },

        handleDownloadFile() {
            if (!this.downloadId) return;
            window.open(this.downloadId, "_blank");
        },
    },
};
</script>

<style lang="less" scoped>
.button-download {
    border-color: #176b6e;
    border-radius: 5px;
    padding: 3px 6px;
    background-color: transparent !important;
    outline: none !important;
    box-shadow: none !important;
    height: 38px;
    color: #176b6e;
    font-size: 24px;
    border-width: 2px;
    margin-left: 10px;
}

.container-download {
    max-width: 1180px;
    margin: 0 auto;
    padding: 48px 20px 72px;
    color: #0e1a28;
    font-family: 'Inter', Arial, sans-serif;
    // margin-top: 20px;
    .download-title {
        font-size: 24px;
        color: #176b6e;
        text-align: center;
    }
}

.page-intro { display: flex; align-items: flex-end; justify-content: space-between; gap: 24px; margin: 0 auto 34px; max-width: 1080px; }
.eyebrow { color: #176b6e; font-size: 11px; font-weight: 700; letter-spacing: 1px; line-height: 1.4; }
.page-intro h1 { margin: 7px 0 8px; color: #102238; font-family: 'Playfair Display', serif; font-size: 38px; line-height: 1.15; letter-spacing: 0; }
.page-intro p { margin: 0; color: #617084; font-size: 15px; line-height: 1.6; }
.file-count { display: flex; flex-direction: column; align-items: flex-end; color: #718096; font-size: 12px; line-height: 1.5; }
.file-count strong { color: #176b6e; font-size: 28px; line-height: 1.1; }
.download-panel { max-width: 1080px; margin: 0 auto; padding: 28px 30px 22px; background: #f8fafc; border: 1px solid #d7e0e8; border-radius: 10px; box-shadow: 0 10px 26px rgba(16, 34, 56, .07); }
.files-heading { display: flex; align-items: center; gap: 14px; margin: 0 0 18px; color: #102238; font-size: 20px; font-weight: 700; line-height: 1.4; letter-spacing: 0; }
.heading-rule { height: 1px; flex: 1; background: #d7e0e8; }
.table-wrap { overflow-x: auto; }
.download-table { width: 100%; min-width: 800px; border-collapse: collapse; table-layout: fixed; }
.download-table th:nth-child(1), .download-table td:nth-child(1) { width: 20%; }
.download-table th:nth-child(2), .download-table td:nth-child(2) { width: 48%; }
.download-table th:nth-child(3), .download-table td:nth-child(3) { width: 10%; }
.download-table th:nth-child(4), .download-table td:nth-child(4) { width: 8%; }
.download-table th:nth-child(5), .download-table td:nth-child(5) { width: 14%; }
.download-table thead { border-top: 1px solid #b9c7d4; border-bottom: 1px solid #b9c7d4; }
.download-table thead th { padding: 13px 12px; color: #526276; font-size: 11px; font-weight: 700; letter-spacing: .5px; line-height: 1.4; text-align: left; text-transform: uppercase; }
.download-table tbody tr { border-bottom: 1px solid #e1e7ed; transition: background-color .15s ease; }
.download-table tbody tr:hover { background: #eef5f7; }
.download-table tbody tr:last-child { border-bottom: 0; }
.download-table tbody td { padding: 17px 12px; color: #4d5e72; font-size: 14px; line-height: 1.5; vertical-align: middle; overflow-wrap: anywhere; }
.download-table tbody td:first-child { color: #102238; font-weight: 700; }
.file-chip { display: inline-block; padding: 4px 7px; border: 1px solid #c7d6df; border-radius: 4px; background: #fff; color: #49667b; font-size: 11px; font-weight: 700; line-height: 1.25; }
.size-cell { white-space: nowrap; color: #536a7d !important; font-variant-numeric: tabular-nums; }
.download-link { display: inline-flex; align-items: center; gap: 6px; color: #176b6e !important; font-weight: 700; text-decoration: none; white-space: nowrap; }
.download-link:hover { color: #0e4e50 !important; text-decoration: underline; }
.unavailable { color: #8a96a5; font-size: 12px; line-height: 1.45; }

@media (max-width: 680px) {
    .container-download { padding: 30px 14px 48px; }
    .page-intro { align-items: flex-start; flex-direction: column; }
    .file-count { align-items: flex-start; }
    .download-panel { padding: 22px 14px 16px; }
}
</style>
